import { useNavigate, useParams } from 'react-router-dom';

import { Page } from '@/components/layout/Page';
import { ErrorState } from '@/components/ui/EmptyState';
import { Spinner } from '@/components/ui/Spinner';
import { useCandidate } from '@/features/candidates/api';

import { SendJobProfiles } from '../components/SendJobProfiles';

export function JobProfileEditorPage() {
  const { id = '' } = useParams();
  const navigate = useNavigate();
  const candidate = useCandidate(id);

  if (candidate.isPending)
    return (
      <Page>
        <Spinner label="Loading candidate" />
      </Page>
    );
  if (candidate.isError)
    return (
      <Page>
        <ErrorState
          message="The candidate could not be loaded."
          onRetry={() => {
            void candidate.refetch();
          }}
        />
      </Page>
    );
  return (
    <SendJobProfiles
      key={id}
      candidate={candidate.data}
      onClose={() => {
        void navigate(`/candidates/${id}`, { replace: true });
      }}
    />
  );
}
